module.exports = __webpack_public_path__ + "img/icon4.9c050264.png";